// How close to the bottom (px) still counts as "following the tail".
// Within this slack we stick to the streaming reply; scroll further up
// and we leave the user where they are.
export const FOLLOW_BOTTOM_THRESHOLD_PX = 80;
// Gap left above a freshly-snapped user question — just enough to clear the
// top fade so the message sits near the top border without exposing a slab of
// the previous turn above it. Exported so the latest-turn floor can subtract
// it (keeping the snap gap and the reserved room in lockstep — see ProjectChat).
export const SNAP_TOP_OFFSET_PX = 16;
export const FADE_RAMP_PX = 24;
